import { render, staticRenderFns } from "./footerSection.vue?vue&type=template&id=3e77f24a&scoped=true"
import script from "./footerSection.vue?vue&type=script&lang=js"
export * from "./footerSection.vue?vue&type=script&lang=js"
import style0 from "./footerSection.vue?vue&type=style&index=0&id=3e77f24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e77f24a",
  null
  
)

export default component.exports